<script>
  // Aqui você pode adicionar lógica se necessário
</script>

<style>
  .unauthorized-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f8f9fa; /* Cor de fundo clara */
  }

  .unauthorized-card {
    text-align: center;
    padding: 2rem;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
    background-color: #ffffff;
  }

  .unauthorized-title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .unauthorized-text {
    font-size: 1.25rem;
    color: #6c757d;
  }

  .unauthorized-icon {
    font-size: 4rem;
    color: #dc3545; /* Cor vermelha para o X */
    margin-bottom: 1rem;
  }

  .contact-button {
    display: inline-block;
    margin-top: 1.5rem;
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    font-weight: bold;
    color: #ffffff;
    background-color: #007bff; /* Cor do botão */
    border: none;
    border-radius: 0.25rem;
    text-decoration: none;
  }

  .contact-button:hover {
    background-color: #0056b3; /* Cor do botão ao passar o mouse */
  }
</style>
<div class="container">
<div class="unauthorized-container">
  <div class="unauthorized-card">
    <div class="unauthorized-icon">
      <i class="bi bi-x-circle-fill"></i>
    </div>
    <div class="unauthorized-title">
      Acesso não autorizado
    </div>
    <div class="unauthorized-text">
      Recurso exclusivo para administradores.
    </div>
    
  </div>
</div>
</div>
<!-- Adicione este link de ícone do Bootstrap no seu index.html ou equivalente -->

